import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import Homepage from '../components/FirstEdition/Homepage';
import Login from '../Login';
import Logout from '../Logout';
import { useEffect, useState } from 'react';
import PublicRoute from './PublicRoute';

const AppRouter = () => {

	const [isAuthing, setIsAuthing] = useState(true);
	const [isAuthed, setIsAuthed] = useState(false);

	useEffect(() => {
		const accessToken = localStorage.getItem('accessToken');

		if (accessToken !== null) {
			setIsAuthed(true);
		};

		setIsAuthing(false);
	}, [isAuthing])

	if (isAuthing) {
		return null;
	}

	return (
		<Router>
			<Switch>
				<Route exact path='/' >
					{(isAuthed) ? <Redirect to='/home' /> : <Redirect to='/login' />}
				</Route>
				<PublicRoute exact isAuthed={isAuthed} path="/login" setIsAuthed={setIsAuthed} restricted={true} component={Login} />
				<PublicRoute exact isAuthed={isAuthed} path="/logout" setIsAuthed={setIsAuthed} restricted={false} component={Logout} />
				<PrivateRoute isAuthed={isAuthed} path="/home" component={Homepage} />

			</Switch>
		</Router>
	);
};

export default AppRouter;
